import React from "react";
import { Container, Row, Col, Placeholder } from "react-bootstrap";

const ProductSkeleton = () => {
    return (
        <div className='product-container'>
            <div className='product-details'>
                <Container>
                    <Row>
                        <Col md='6' className='product-img'>
                            <div className='main-product-image'>
                                <Placeholder as='div' animation='glow'>
                                    <Placeholder xs={12} style={{ height: "400px", borderRadius: "30px" }} />
                                </Placeholder>
                            </div>
                            <div className='similar-items'>
                                <Placeholder as='h5' animation='glow'>
                                    <Placeholder xs={3} />
                                </Placeholder>
                                <div className='similar-wrapper d-flex'>
                                    {[1, 2].map((i) => (
                                        <div key={i} className='similar-product-item flex-fill' style={{ margin: "10px" }}>
                                            <Placeholder as='div' animation='glow'>
                                                <Placeholder xs={12} style={{ height: "100px", borderRadius: "5px" }} />
                                            </Placeholder>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                        <Col md='6' className='ps-md-0'>
                            <div className='product-detail-desp-box' style={{ minHeight: "600px" }}>
                                <Placeholder as='div' animation='glow' className='mb-2'>
                                    <Placeholder xs={6} />
                                </Placeholder>
                                <Placeholder as='h1' animation='glow' className='mb-3'>
                                    <Placeholder xs={8} />
                                </Placeholder>
                                <div className='d-flex mb-4'>
                                    <Placeholder as='span' animation='glow' className='me-2'>
                                        <Placeholder xs={2} style={{ height: "24px", width: "60px" }} />
                                    </Placeholder>
                                    <Placeholder as='span' animation='glow'>
                                        <Placeholder xs={2} style={{ height: "24px", width: "80px" }} />
                                    </Placeholder>
                                </div>
                                <div className='price mb-4'>
                                    <Placeholder as='div' animation='glow'>
                                        <Placeholder xs={12} style={{ height: "60px", borderRadius: "5px" }} />
                                    </Placeholder>
                                </div>
                                <div className='mb-4'>
                                    <Placeholder as='div' animation='glow'>
                                        <Placeholder xs={12} style={{ height: "48px" }} />
                                    </Placeholder>
                                </div>
                                <div className='desc-table'>
                                    {[1, 2, 3].map((i) => (
                                        <div key={i} className='mb-3'>
                                            <Placeholder as='p' animation='glow'>
                                                <Placeholder xs={4} />
                                            </Placeholder>
                                            <Placeholder as='div' animation='glow'>
                                                <Placeholder xs={12} />
                                                <Placeholder xs={10} />
                                            </Placeholder>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default ProductSkeleton;
